import { useStore } from 'effector-react'
import { $commission } from '~/entities/Balance/model'
import { CURRENCY } from '~/shared/config/constants'
import { Wrapper, Title, CommissionSkeleton } from './styled'

type CommissionProps = {
  isLoading: boolean
}

export function Commission({ isLoading }: CommissionProps) {
  const commission = useStore($commission)

  if (!commission?.commissionAmount && !isLoading) {
    return (
      <Title>
        Размер комиссии будет уточнен после выбора <br /> карты и ввода суммы
      </Title>
    )
  }
  return (
    <Wrapper>
      <div>Комиссия</div> —{' '}
      {isLoading ? (
        <CommissionSkeleton />
      ) : (
        <span>
          {commission?.commissionAmount || 0} {CURRENCY}
        </span>
      )}
    </Wrapper>
  )
}
